var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"You can live a long, full life with HIV.","answer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }